export default __webpack_public_path__ + "1b686c7bf56047dfc04404a9eb00c581.png";